import React from "react";
import { Route } from "react-router-dom";

const LaunchRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Component {...props} {...rest} key={rest.location?.key} />
      )}
    />
  );
};

export default LaunchRoute;
